/** Agents product release; bump `ATW_AGENTS_VERSION` at repo root (next: 27.2.028). */
import agentsReleaseRaw from "../../ATW_AGENTS_VERSION?raw";

const ATW_AGENTS_RELEASE_VERSION = agentsReleaseRaw.trim();

export function getAtwAgentsReleaseVersion(): string {
  const fromEnv = import.meta.env.VITE_ATW_AGENTS_RELEASE_VERSION?.trim();
  return fromEnv || ATW_AGENTS_RELEASE_VERSION || "27.2.001";
}

export function formatAtwReleaseLabel(version: string): string {
  const v = version.trim();
  if (!v) return "dev";
  if (v.startsWith("v")) return v;
  return `v${v}`;
}
